import React from 'react'
import { useTranslation } from 'react-i18next'
import ThemeToggle from '../../components/ui/ThemeToggle'

export default function Index({ message }) {
  const { t } = useTranslation()
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          {message}
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Inertia.js + React is working!
        </p>
      </div>
    </div>
  )
}
